import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { TrendingUp, TrendingDown, Activity } from "lucide-react";

export default function VolatilityWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/volatility");
        if (mounted) setData(data);
      } catch {}
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  const renderRow = (key, item) => {
    if (!item) return null;
    const up = (item.change_pct ?? 0) >= 0;
    return (
      <div key={key} className="border-b border-white/5 last:border-0 py-3" data-testid={`ticker-${key}`}>
        <div className="flex justify-between items-baseline">
          <div>
            <div className="font-mono-data text-[10px] tracking-[0.25em] uppercase text-text-secondary">
              {item.name}
            </div>
            <div className="font-display text-2xl mt-1">
              {item.current != null ? `$${Number(item.current).toFixed(2)}` : "—"}
            </div>
          </div>
          <div className={`flex items-center gap-1 ${up ? "ticker-up" : "ticker-down"}`}>
            {up ? <TrendingUp className="w-4 h-4" /> : <TrendingDown className="w-4 h-4" />}
            <span className="font-mono-data text-sm">
              {(item.change_pct ?? 0).toFixed(2)}%
            </span>
          </div>
        </div>
        <div className="font-mono-data text-[10px] text-text-secondary mt-1">{item.unit}</div>
      </div>
    );
  };

  return (
    <div className="glass p-5" data-testid="volatility-widget">
      <div className="flex items-center gap-2 mb-4">
        <Activity className="w-4 h-4 text-amber-500" />
        <span className="font-mono-data text-[10px] tracking-[0.3em] uppercase text-text-secondary">
          Volatility · Live
        </span>
      </div>
      {data ? (
        <div>
          {renderRow("crude", data.crude)}
          {renderRow("steel", data.steel)}
          {data.fallback && (
            <div className="font-mono-data text-[9px] text-amber-500/70 mt-2">Cached feed</div>
          )}
        </div>
      ) : (
        <div className="font-mono-data text-xs text-text-secondary animate-pulse">Loading feed...</div>
      )}
    </div>
  );
}
